// Test IDs for WalletSavedCardsSection
export const WALLET_SAVED_CARDS_TEST_IDS = {
  root: 'wallet-saved-cards-section',
  cardsList: 'wallet-saved-cards-list',
  cardRow: 'wallet-saved-card-row',
  addCardRow: 'wallet-add-card-row',
  addCta: 'wallet-add-card-cta',
  editCta: 'wallet-edit-card-cta',
  deleteCta: 'wallet-delete-card-cta',
  folioDeliveryCta: 'wallet-folio-delivery-cta',
  primaryBadge: 'wallet-primary-badge',
  skeletonLoader: 'wallet-saved-cards-skeleton',
};

// Tracking keys for analytics
export const WALLET_SAVED_CARDS_TRACKING_KEYS = {
  addCta: 'addCta',
  editCta: 'editCta',
  deleteCta: 'deleteCta',
  folioDeliveryCta: 'folioDeliveryCta',
};

// Modal IDs (reuse from Profile Page constants)
export const SAVED_CARDS_MODAL_IDS = {
  ADD_CARD: 'add-saved-card',
  EDIT_CARD: 'edit-saved-card',
  FOLIO_DELIVERY: 'folio-delivery-saved-card',
  DELETE_CARD: 'delete-saved-card',
};
